import { render, staticRenderFns } from "./RefundDetails.vue?vue&type=template&id=20066c72&"
import script from "./RefundDetails.vue?vue&type=script&lang=js&"
export * from "./RefundDetails.vue?vue&type=script&lang=js&"
import style0 from "./RefundDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports